<ng-container *ngIf="isMobileView; then mobile; else desktop"></ng-container>

<ng-template #mobile>
  <moduurnv2-review-and-pay></moduurnv2-review-and-pay>
</ng-template>

<ng-template #desktop>
  <moduurnv2-review-and-pay-desktop></moduurnv2-review-and-pay-desktop>
</ng-template>
